import 'date-fns';
import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useMediaQuery } from "react-responsive";
import { useDispatch,useSelector } from "react-redux";
import {usageGraphData} from "../e_model/e_action";
import moment from "moment";
import {usageService} from "../e_service/e_service";

export default function MaterialUIPickers(props) {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 577 });
  const YEAR_DATE_FORMAT = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_PICKER_FORMAT
);
  
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container direction={isTabletOrMobile ? "column" : "row"}>
      
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="Start Date"
          format={YEAR_DATE_FORMAT}
          value={props?.customstartDate}
          minDate={props?.saStartDate}
          maxDate={new Date()}
          onChange={props?.handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <KeyboardDatePicker
          margin="normal"
          id="date-picker"
          label="End Date"
          format={YEAR_DATE_FORMAT}
          minDate={props?.saStartDate && props?.customstartDate}
          maxDate={ props?.monthCustomRange==true  ? moment(new Date()) : moment(props?.customstartDate).add(30, 'days')}
          value={props?.customendDate}
          onChange={props?.handleEndDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
      </Grid>

    </MuiPickersUtilsProvider>
  );
}